import { Form, Formik } from "formik";
import ThemedModal from "../../../@ui/Modal/ThemedModal";
import {
  NotificationCreateRequest,
  Notification,
  NotificationUpdateRequest,
  NotificationFormModel,
} from "../../../types/Notification";
import { Button, Modal } from "react-bootstrap";
import NotificationForm from "./NotificationForm";
import { notificationSchema } from "./schema";
import { DateTime } from "luxon";

interface NotificationFormModalProps {
  show: boolean;
  onClose: () => void;
  notification?: Notification | null;
  onSubmit: (
    values: NotificationCreateRequest | NotificationUpdateRequest
  ) => void;
  apiErrorMessage?: string;
}
const NotificationFormModal = ({
  show,
  onClose,
  notification,
  onSubmit,
  apiErrorMessage,
}: NotificationFormModalProps) => {
  const initialValues = notification
    ? ({
        notificationId: notification.notificationId,
        message: notification.message,
        notificationDate: notification.notificationDate.toISODate() || "",
        notificationTime:
          notification.notificationDate
            .setZone("local")
            .set({ millisecond: 0 })
            .toISOTime({
              suppressSeconds: true,
              suppressMilliseconds: true,
              includeOffset: false,
            }) || "",
      } as NotificationFormModel)
    : (() => {
        const now = DateTime.local()
          .setZone("local")
          .set({ millisecond: 0, second: 0 });

        return {
          message: "",
          notificationDate: now.toISODate() || "",
          notificationTime:
            now.toISOTime({
              suppressMilliseconds: true,
              includeOffset: false,
            }) || "",
        } as NotificationFormModel;
      })();

  const handleSubmit = (values: NotificationFormModel) => {
    const combined = DateTime.fromISO(
      `${values.notificationDate}T${values.notificationTime}`,
      { zone: "local" }
    );
    if (!combined.isValid) {
      console.error("Invalid date/time combination");
      return;
    }
    const isoDate = combined.toISO({ suppressMilliseconds: true });

    if (values.notificationId) {
      const updateModel: NotificationUpdateRequest = {
        notificationId: values.notificationId,
        message: values.message!,
        notificationDate: isoDate!,
      };
      onSubmit(updateModel);
    } else {
      const createModel: NotificationCreateRequest = {
        message: values.message!,
        notificationDate: isoDate!,
      };
      onSubmit(createModel);
    }
  };

  return (
    <ThemedModal centered show={show} onHide={onClose}>
      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues ?? {}}
        validationSchema={notificationSchema}
      >
        {({ handleSubmit, values }) => (
          <Form onSubmit={handleSubmit}>
            <Modal.Header>
              <Modal.Title>
                {notification ? "Edit" : "Create"} Notification
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {apiErrorMessage && (
                <div className="p-1 bg-danger text-white mb-2">
                  {apiErrorMessage}
                </div>
              )}

              <NotificationForm />
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="text-white"
                variant="secondary"
                onClick={onClose}
              >
                Cancel
              </Button>
              <Button className="text-white" type="submit">
                {notification ? "Update" : "Create"}
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </ThemedModal>
  );
};
export default NotificationFormModal;
